// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import CashReceiptHeader from "../../components/bill/default/CashReceiptHeader";
import CashReceiptBody from "../../components/bill/default/CashReceiptBody";
import CashReceiptFooter from "../../components/bill/default/CashReceiptFooter";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  SETTINGS_API_01,
  SETTINGS_API_09,
  SETTINGS_API_20,
  ORDER_API_06,
} from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import PrintKOTBody from "../../components/bill/kot/PrintKOTBody";
// imports section End

function PrintKOT() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();

  const [billOptions, setBillOptions] = useState([]);
  const [mappedOptions, setMappedOptions] = useState(new Set());
  const [dataLoaded, setDataLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [billDetails, setBillDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const orderCode = queryParams.get("orderCode");
  const source = queryParams.get("source");

  console.log("queryParams", source);

  useEffect(() => {
    if (orderCode) {
      fetchBillDetails();
    }
  }, [orderCode]);

  useEffect(() => {
    fetchBillOptions();
    fetchMappedOptions();
  }, []);

  useEffect(() => {
    if (!loading && !error) {
      // Automatically print the receipt when the page loads
      window.print();
    }
  }, [loading, error]);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, CATTYPE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  // API calls start
  const fetchBillDetails = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        ORDERCODE: orderCode,
      };
      const response = await externalgetApi(ORDER_API_06, "GET", params);

      console.log("fetchBillDetails fetchBillDetails", response);
      setBillDetails(response);
    } catch (error) {
      console.error("Error fetching bill details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBillOptions = async () => {
    try {
      const params = {
        STS: CON_STATUS_ACTIVE,
      };

      const response = await externalgetApi(SETTINGS_API_20, "GET", params);
      console.log("fetchBillOptions", response);

      setBillOptions(response);
    } catch (error) {
      console.error("Error fetching Bill Options:", error);
      setError(error);
    } finally {
      setDataLoaded(true);
    }
  };

  const fetchMappedOptions = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      };

      const response = await externalgetApi(SETTINGS_API_01, "GET", params);
      // Parse mapped options JSON (e.g., JTEXT field)

      const mappedOptionsArray = JSON.parse(response[0]?.JTEXT || "[]");
      const mappedIds = new Set(
        mappedOptionsArray.map((opt) => opt.BILLOPTCODE)
      ); // Using a Set for quick lookup
      setMappedOptions(mappedIds);
    } catch (error) {
      console.error("Error fetching Mapped Options:", error);
    }
  };
  // API calls end

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 4,
        mb: 4,
      }}
    >
      <Box
        sx={{
          width: 300,
          padding: 2,
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        {/* <CashReceiptHeader
          billOptions={billOptions}
          mappedOptions={mappedOptions}
          orderPayload={billDetails}
        /> */}
        <PrintKOTBody
          billOptions={billOptions}
          mappedOptions={mappedOptions}
          orderPayload={billDetails}
          source={source}
        />

        {/* <CashReceiptFooter
          billOptions={billOptions}
          mappedOptions={mappedOptions}
          orderPayload={billDetails}
        /> */}
      </Box>
    </Box>
  );
}

export default PrintKOT;
